import React from 'react';

interface IconButtonProps {
    onClick: () => void;
    icon?: string;
    title?: string;
    testId?: string;
    disabled?: boolean;
    children?: React.ReactNode;
}

const IconButton: React.FC<IconButtonProps> = ({
    onClick,
    icon,
    title,
    testId,
    disabled,
    children,
}) => (
    <button
        className="data-table__icon-btn"
        onClick={(e) => {
            e.stopPropagation();
            onClick();
        }}
        title={title}
        data-testid={testId}
        disabled={disabled}
    >
        {icon ? <span className={icon} /> : children}
    </button>
);

export default IconButton;
